import React, { FC, useRef, useState } from 'react';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
//devextreem
import { TextBox } from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import ModalFooter from 'components/appModalFooter';
import { isSuccess } from 'utils/responseStatus';

import {
  useCreateTransportBrandMutation,
  useEditTransportBrandMutation,
  useLazyGetTransportBrandDetailQuery,
} from 'bus/transportBrand/transportBrand';
import { TransportBrandItem } from 'bus/transportBrand/types';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const initialForm: TransportBrandItem = {
  id: null,
  name: '',
};

const DetailModalRole: FC<DetailModalRoleProps> = ({ changeVisible, id, refresh, visible }) => {
  const [getTransportBrandDetail] = useLazyGetTransportBrandDetailQuery();
  const [createTransportBrand, { isLoading: isCreateLoading }] = useCreateTransportBrandMutation();
  const [patchTransportBrand, { isLoading: isEditLoading }] = useEditTransportBrandMutation();

  let createTransportGroupRef = useRef<any>(null);
  let createTransportGroupValidationRef = useRef<any>(null);

  const [form, setForm] = useState<TransportBrandItem>(initialForm);

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createTransportGroupValidationRef.current.instance.validate().isValid) {
      if (id) {
        await patchTransportBrand(form).then((resp: any) => {
          if (isSuccess(resp)) {
            changeVisible(false);
            refresh();
          }
        });
      } else {
        await createTransportBrand({ name: form.name }).then((resp: any) => {
          if (isSuccess(resp)) {
            changeVisible(false);
            refresh();
          }
        });
      }
    }
  };

  const onShown = async () => {
    createTransportGroupValidationRef.current.instance.reset();
    if (id) {
      let result = await getTransportBrandDetail({ id });
      if (isSuccess(result)) {
        const data: any = 'data' in result ? (result as any).data : (result as any);
        setForm((prev) => ({ ...prev, ...data }));
      }
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createTransportGroupValidationRef.current.instance.reset();
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Марка"
        width={300}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createTransportGroupValidationRef}>
                <Form id="mark-transport" formData={form} ref={createTransportGroupRef}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <TextBox
                          stylingMode="underlined"
                          placeholder="VOLVO"
                          mode="text"
                          value={form.name}
                          onValueChange={(e) => {
                            setForm((prev) => ({ ...prev, name: e }));
                          }}
                        >
                          <Validator>
                            <RequiredRule message="Заполните поле марка" />
                          </Validator>
                        </TextBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isCreateLoading || isEditLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
